import { businessServiceRoute } from './businessServices'

export const lifecycleContent = {
  hero: {
    title: 'SecureFix for',
    accent: 'Business',
    subtitle:
      'SecureFix sources, configures, deploys and manages business devices end to end, so your team stays productive from day one to secure retirement.',
  },
  partners: ['Google', 'HP', 'Lenovo', 'Microsoft', 'Apple'],
  overview: [
    {
      icon: '💻',
      title: 'Business Laptop Sourcing',
      description: 'Source the right devices at competitive rates for your team size and workload.',
      route: businessServiceRoute('procurement'),
    },
    {
      icon: '🚀',
      title: 'End-to-End Deployment',
      description: 'From unboxing to desk-ready setup, we handle staging, imaging and delivery.',
      route: businessServiceRoute('deployment'),
    },
    {
      icon: '⚙️',
      title: 'OS & Software Setup',
      description: 'Windows or macOS configured with your apps, accounts and company policies.',
      route: businessServiceRoute('os-setup'),
    },
    {
      icon: '🔐',
      title: 'Security & Compliance',
      description: 'Encryption, antivirus, updates and controls aligned to your security needs.',
      route: businessServiceRoute('security'),
    },
    {
      icon: '🛠️',
      title: 'Support & Maintenance',
      description: 'Ongoing repair, health checks and replacements to keep fleets running.',
      route: businessServiceRoute('support'),
    },
    {
      icon: '🔄',
      title: 'Device Lifecycle Management',
      description: 'Full control from purchase through refresh, recycle and secure disposal.',
      route: businessServiceRoute('lifecycle-management'),
    },
  ],
  configuration: {
    title: 'Device Configuration',
    text: 'Every laptop leaves SecureFix ready for work. We apply the settings, security and software your business needs before devices reach your staff.',
    items: [
      { icon: '🪟', label: 'Windows / macOS Setup' },
      { icon: '🛡️', label: 'Managed Antivirus' },
      { icon: '🔑', label: 'BitLocker Encryption' },
      { icon: '👤', label: 'User Accounts & Profiles' },
      { icon: '📧', label: 'Email & Productivity Apps' },
      { icon: '☁️', label: 'Cloud Drive Sync' },
      { icon: '📡', label: 'Wi-Fi & VPN Ready' },
      { icon: '🏷️', label: 'Asset Labels' },
      { icon: '📦', label: 'Baseline Imaging' },
      { icon: '✅', label: 'Pre-Delivery Testing' },
    ],
  },
  deployment: {
    title: 'Deployment Services',
    text: 'Scale onboarding without slowing your IT team. We prepare devices in bulk and roll them out with clear asset tracking.',
    items: [
      { icon: '📋', label: 'Staging & Imaging' },
      { icon: '🏷️', label: 'Asset Tagging & Tracking' },
      { icon: '☁️', label: 'Cloud Integration' },
      { icon: '👥', label: 'User Onboarding Packs' },
      { icon: '🚚', label: 'Desk-Side Delivery' },
      { icon: '📊', label: 'Rollout Reporting' },
      { icon: '🔁', label: 'Swap & Refresh Kits' },
      { icon: '🏢', label: 'Multi-Site Deployment' },
    ],
  },
  lifecycle: {
    title: 'Device Lifecycle Management',
    text: 'Keep costs predictable and security tight across the full life of every device, from first login to certified wipe.',
    features: [
      'Regular health checks',
      'Performance monitoring',
      'Warranty & repair handling',
      'Scheduled device refreshes',
      'Secure data erasure',
      'Responsible recycling options',
      'Spare device pool support',
      'Clear lifecycle reporting',
    ],
  },
  whyUs: [
    'London-based team with same-day repair capability',
    'Business-focused procurement and rollout support',
    'Secure wipe and recycling when devices retire',
    'Transparent quotes with no hidden surprises',
    'Support for mixed Windows and Apple fleets',
    'One partner for buy, deploy, fix and recycle',
  ],
  industries: [
    { icon: '🎓', label: 'Education' },
    { icon: '🏥', label: 'Healthcare' },
    { icon: '💰', label: 'Finance' },
    { icon: '🏭', label: 'Manufacturing' },
    { icon: '⚖️', label: 'Legal' },
    { icon: '🛒', label: 'Retail' },
    { icon: '🏗️', label: 'Construction' },
    { icon: '📢', label: 'Marketing' },
    { icon: '💻', label: 'IT & Tech' },
    { icon: '🏛️', label: 'Public Sector' },
    { icon: '🏨', label: 'Hospitality' },
    { icon: '🚚', label: 'Logistics' },
  ],
  additional: [
    { icon: '🖥️', label: 'Managed IT Support' },
    { icon: '🔐', label: 'Cybersecurity' },
    { icon: '🎧', label: 'Helpdesk Support' },
    { icon: '♻️', label: 'Secure Recycling' },
    { icon: '🛠️', label: 'On-Site Repairs' },
  ],
}
